<template>
  <div class="pa-4">
    <h2 class="mb-3 text-center">
      {{ $t('servicesystem.loginform.text.resetpassword') }}
    </h2>
    <p class="text-center">
      {{ $t('servicesystem.loginform.text.resetpassword_body') }}
    </p>
    <p v-if="errorText" class="error--text text-center">{{ errorText }}</p>
    <v-form v-model="valid" ref="form">
      <v-row no-gutters>
        <v-text-field ref="emailfield" :label="$t('servicesystem.loginform.text.login_email')" v-model="computedEmail"
          :rules="[requiredRule, emailRule]" class="mt-1 mb-8">
        </v-text-field>
      </v-row>
    </v-form>

    <WideBtn :text="$t('servicesystem.common_objects.commonterms.send')" color="var(--v-primary-base)"
      :disabled="!valid" :loading="taskInProgress" @click="requestOtp()">
    </WideBtn>
    <WideBtn :text="$t('servicesystem.common_objects.commonterms.cancel')" color="var(--v-primary-base)"
      :disabled="taskInProgress" :filled="false" @click="$emit('cancel')">
    </WideBtn>
  </div>
</template>


<script>
import http from "@/api/client";
import WideBtn from "@/components/WideBtn.vue";
import QInputRuleMixin from "@/helpers/Mixins/QInputRuleMixin";

export default {
  name: "OTPContent",
  model: {
    prop: "email",
    event: "change",
  },
  props: {
    email: String,
  },
  components: {
    WideBtn
  },
  mixins: [QInputRuleMixin],

  data() {
    return {
      valid: false,

      taskInProgress: false,
      errorText: "",
    };
  },

  methods: {
    requestOtp() {
      this.taskInProgress = true;
      this.errorText = "";
      http()
        .post("/api2/Accounts/RecoverPassword", { username: this.email })
        .then(() => {
          this.$emit("next");
        })
        .catch((error) => {
          console.error(error);
          if (error) {
            this.errorText = error.data.Message;
          }
          else {
            this.errorText = "An error occurred while validating the code.";
          }
        }).finally(() => {
          this.taskInProgress = false;
        });
    },
  },

  computed: {
    computedEmail: {
      get() {
        return this.email
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>